import authAxios from "../axios-instance/authAxios";

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export const OpenApiApi = {
    getApiKey,
    issueApiKey,
    revokeApiKey,
}

async function getApiKey({ headers, params }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/open-api/api-key`, {
        headers: headers,
        params: params,
    })
}

async function issueApiKey({ headers, body }) {
    return await authAxios.post(`${MAIN_API_HOST}/v2/public/open-api/api-key`, body, {
        headers: headers,
    })
}

async function revokeApiKey({ headers, body }) {
    return await authAxios.delete(`${MAIN_API_HOST}/v2/public/open-api/api-key`, {
        headers: headers,
        data: body,
    })
}
